import React from 'react';
import './DataVerificationTooltip.css';

const DataVerificationTooltip = ({ dataVerification, children }) => {
  const [showTooltip, setShowTooltip] = React.useState(false);

  if (!dataVerification || dataVerification.is_complete) {
    return children;
  }

  const missingFields = dataVerification.missing_fields || [];
  
  if (missingFields.length === 0) {
    return children;
  }

  // Convert field names to readable format
  const formatFieldName = (field) => {
    return field
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <div 
      className="verification-tooltip-wrapper"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {children}
      
      {showTooltip && missingFields.length > 0 && (
        <div className="data-verification-tooltip">
          <div className="tooltip-title">Missing Fields:</div>
          <ul className="tooltip-fields">
            {missingFields.map((field, index) => (
              <li key={index}>
                <span className="tooltip-field-icon">○</span>
                <span>{formatFieldName(field)}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DataVerificationTooltip;
